import { z } from 'zod';
export const OidcProviderSchema = z.object({
    providerId: z.string(),
    homePage: z.string().optional(),
    title: z.string(),
    logoUser: z.string().optional(),
});
export const AccountManagementPublicSettingsSchema = z.object({
    oidcProviders: z.array(OidcProviderSchema).optional(),
});
const UserInfosSchema = z.object({
    self: z.string(),
    displayName: z.string(),
    email: z.string(),
    franceConnect: z.boolean().optional(),
    providerInfos: z.object({}).optional(),
    dateTimeLastLogin: z.date().or(z.string()).optional(),
});
//# sourceMappingURL=account-management.js.map